import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CircularProgress from '@mui/material/CircularProgress/CircularProgress';
import Stack from '@mui/material/Stack/Stack';

import ModalNotification from '@/shared/components/dialogs/ModalNotification';
import WaveUICustomersSearchBar from '@/shared/components/widgets/WaveUICustomersSearchBar';
import Customer from '@/shared/types/customer.type';

type TileCustomerAssignDialogProps = {
  searchBoxProps: {
    customers: Customer[] | null;
    searchCustomerValue: string;
    assignedCustomer: Customer | null;
    selectCustomer: (customerId: string) => void;
    searchCustomer: (value: string) => void;
  };
  loaders: {
    updateQuote: boolean;
    searchCustomer: boolean;
  };
  onClose: () => void;
  proceed: () => void;
};

const TileCustomerAssignDialog: FC<TileCustomerAssignDialogProps> = ({
  searchBoxProps,
  loaders,
  onClose,
  proceed,
}) => {
  const { t } = useTranslation(['checkout', 'common']);

  return (
    <ModalNotification
      size='xs'
      fullWidth
      open
      onClose={onClose}
      dialogProps={{
        title: t('checkout:assignCustomer'),
        content: (
          <Stack sx={{ py: 1, gap: 2 }}>
            {searchBoxProps.customers && (
              <WaveUICustomersSearchBar
                loading={loaders.searchCustomer}
                searchCustomersList={searchBoxProps.customers}
                selectedCustomer={searchBoxProps.assignedCustomer}
                searchCustomerValue={searchBoxProps.searchCustomerValue}
                setSearchCustomerValue={searchBoxProps.searchCustomer}
                setSelectedCustomerId={(customer) => {
                  searchBoxProps.selectCustomer(customer);
                }}
              />
            )}
          </Stack>
        ),
        actions: [
          {
            variant: 'text',
            label: t('common:cancel'),
            onClick: onClose,
          },
          {
            variant: 'contained',
            label: t('common:assign'),
            icon: loaders.updateQuote ? (
              <CircularProgress
                size='small'
                sx={{ color: '#fff', width: 16, height: 16, mr: 1 }}
              />
            ) : null,
            onClick: () => {
              if (!loaders.updateQuote) {
                return proceed();
              }
            },
          },
        ],
      }}
    />
  );
};

export default TileCustomerAssignDialog;
